import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IProductCategory, IProductCategoryDropdown, IProductCategoryState } from "../../../types/productCategory/productCategoryInterfaces";

export const initialState: IProductCategoryState = {
    productCategories: [],
    productCategoriesDropdown: [],
    productCategorySelected: null,
};

export const productCategorySlice = createSlice({
    name: "productCategories",
    initialState,
    reducers: {
        /**
         * Cargar todas las categorías de productos.
         */
        loadingProductCategories: (state, action: PayloadAction<IProductCategory[]>) => {
            state.productCategories = action.payload;
        },

        /**
         * Cargar las categorías de productos para el dropdown.
         */
        loadingProductCategoriesDropdown: (state, action: PayloadAction<IProductCategoryDropdown[]>) => {
            state.productCategoriesDropdown = action.payload;
        },

        /**
         * Activar o desactivar una categoría.
         */
        deactivateStateProductCategory: (state, action: PayloadAction<{ id: number; status: boolean }>) => {
            const { id, status: newState } = action.payload;
            state.productCategories = state.productCategories.map((category) =>
                category.id === id ? { ...category, status: newState } : category
            );
        },

        /**
         * Agregar una nueva categoría de producto.
         */
        addProductCategory: (state, action: PayloadAction<IProductCategory>) => {
            state.productCategories = [...state.productCategories, action.payload];
        },

        /**
         * Actualizar una categoría de producto.
         */
        updateProductCategory: (state, action: PayloadAction<IProductCategory>) => {
            state.productCategories = state.productCategories.map((category) =>
                category.id === action.payload.id ? { ...category, ...action.payload } : category
            );
        },
    },
});

export const {
    loadingProductCategories,
    loadingProductCategoriesDropdown,
    deactivateStateProductCategory,
    addProductCategory,
    updateProductCategory,
} = productCategorySlice.actions;

export default productCategorySlice.reducer;
